export const formatCurrency = (cents: number, maximumFractionDigits = 2) =>
  new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    maximumFractionDigits,
  }).format(cents / 100);

interface ProjectionInput {
  averageOrderCents: number;
  marketplaceRateBps: number;
  processingRateBps: number;
  processingFixedCents: number;
  fulfilmentCostCents: number;
  supportCostCents: number;
  marketingCostCents: number;
  inHouseDeliveryCostCents: number;
  customerDeliveryFeeCents: number;
  ordersPerDay: number;
  deliveryDaysPerWeek: number;
}

export interface Projection {
  marketplaceCostPerOrderCents: number;
  directCostPerOrderCents: number;
  retainedPerOrderCents: number;
  retainedPerDeliveryDayCents: number;
  retainedPerYearCents: number;
  annualOrders: number;
}

export function marketplaceFeeCents(
  orderValueCents: number,
  commissionBasisPoints: number,
): number {
  return Math.round(
    (orderValueCents * commissionBasisPoints) / 10_000,
  );
}

export function directContributionCents(input: {
  orderValueCents: number;
  processingCents: number;
  fulfilmentCents: number;
  deliveryCents: number;
}): number {
  return (
    input.orderValueCents -
    input.processingCents -
    input.fulfilmentCents -
    input.deliveryCents
  );
}

export function calculateProjection(input: ProjectionInput): Projection {
  const marketplaceCostPerOrderCents = marketplaceFeeCents(
    input.averageOrderCents,
    input.marketplaceRateBps,
  );
  const processingCostCents =
    Math.round((input.averageOrderCents * input.processingRateBps) / 10_000) +
    input.processingFixedCents;
  const netDeliveryCostCents = Math.max(
    input.inHouseDeliveryCostCents - input.customerDeliveryFeeCents,
    0,
  );
  const directCostPerOrderCents =
    processingCostCents +
    input.fulfilmentCostCents +
    input.supportCostCents +
    input.marketingCostCents +
    netDeliveryCostCents;
  const retainedPerOrderCents =
    marketplaceCostPerOrderCents - directCostPerOrderCents;
  const annualOrders =
    input.ordersPerDay * input.deliveryDaysPerWeek * 52;

  return {
    marketplaceCostPerOrderCents,
    directCostPerOrderCents,
    retainedPerOrderCents,
    retainedPerDeliveryDayCents:
      retainedPerOrderCents * input.ordersPerDay,
    retainedPerYearCents: retainedPerOrderCents * annualOrders,
    annualOrders,
  };
}
